/// <reference path="../wpt.ts" />
/*
    User group administration page - standalone, does not inherit widgets.
*/
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        class DetailLayoutUserGroupAdmin extends Navigation.DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                super(typeName, core, handler, custom, context, readyCallback, secondaryActivationCallback);
                this._autoGroupKeyword = null;
                this._autoUserKeyword = null;
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty("DetailViews")) {
                    let viewConfig = appConfig.DetailViews[this._name];
                    if (viewConfig != null) {
                        if (viewConfig.hasOwnProperty("GroupSecurityKeyword"))
                            this._autoGroupKeyword = viewConfig.GroupSecurityKeyword;
                        if (viewConfig.hasOwnProperty("UserSecurityKeyword"))
                            this._autoUserKeyword = viewConfig.UserSecurityKeyword;
                    }
                }
            }
            _postActivationActivity() {
                
                let glWidget = this._instancesByPlaceholder['leftColumnPlaceholder1'];
                if (this._autoGroupKeyword)
                    glWidget.AutoGroupKeyword = this._autoGroupKeyword;
                if (this._autoUserKeyword)
                    glWidget.AutoUserKeyword = this._autoUserKeyword;
                super._postActivationActivity();
            }
        }
        Navigation.DetailLayoutUserGroupAdmin = DetailLayoutUserGroupAdmin;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
